import {Helmet} from '@dr.pogodin/react-helmet';
import {CarouselSwiper, toSlideImages} from '@online-offer/shared';
import {Box, Heading, HStack, Icon, Show, Stack, Text, VStack} from 'platform/foundation';
import {Lightbox, useLightbox} from 'platform/lightbox';
import {useDateTimeFormatter} from 'platform/locale';

import {parseDate} from 'shared/web';

import {CarouselButton} from '../../components/CarouselButton/CarouselButton';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {translateWithFallback as t} from '../../utils/translateWithFallback';

export function Hero() {
  const {saleVehiclePhotos, vehicle, afterSale} = useGetOnlineOfferData();
  const formatDateTime = useDateTimeFormatter();

  const [heroLightboxControls, {onOpenBySlide}] = useLightbox('hero');

  const images = toSlideImages(saleVehiclePhotos);

  return (
    <section id="hero">
      <Helmet>
        <title>{vehicle?.title}</title>
      </Helmet>

      <Box width="100%" overflow="hidden" backgroundColor="fill.white">
        <VStack align="center">
          <Box
            width="100%"
            maxWidth={432}
            paddingTop={[4, 3, 3, 3]}
            paddingBottom={[4, 6, 6, 8]}
            paddingHorizontal={[3, 8, 8, 20]}
          >
            <Stack direction={['column', 'row']} spacing={3} align={['flex-start', 'center']} wrap>
              <Heading size={1}>{vehicle?.title}</Heading>
              <Show when={afterSale}>
                {(sale) => (
                  <Box
                    backgroundColor="semantic.bg.green"
                    borderRadius="border_radius_full"
                    paddingHorizontal={3}
                    paddingVertical={1}
                    data-testid="afterSaleBadge"
                  >
                    <HStack spacing={2} align="center">
                      <Icon value="good" size={4} color="text.successDark" />
                      <Text size="small" color="successDark">
                        {t('afterSale.handedOverOn', 'Vehicle handed over on {date}', {
                          date: formatDateTime('dateShort', parseDate(sale.closedAt)),
                        })}
                      </Text>
                    </HStack>
                  </Box>
                )}
              </Show>
            </Stack>
          </Box>
          <Box width="100%">
            <CarouselSwiper
              CarouselButtonComponent={CarouselButton}
              images={images}
              onInspectImage={(slide) => onOpenBySlide(slide, images)}
            />
          </Box>
          <Lightbox data-testid="hero" controls={heroLightboxControls} images={images} />
        </VStack>
      </Box>
    </section>
  );
}
